<template>
  <VaCard>
    <VaCardTitle>{{ t('home.upcomingBirthdays') }}</VaCardTitle>
    <VaCardContent>
      <VaInnerLoading :loading="loading">
        <div v-if="birthdays.length === 0" class="text-center text-gray-500 py-4">
          {{ t('home.noBirthdays') }}
        </div>
        <div v-else class="flex flex-col gap-3">
          <div v-for="entry in birthdays" :key="entry.id" class="flex justify-between items-center">
            <router-link
              :to="{ name: 'admin.users.edit', params: { id: entry.id } }"
              class="text-primary font-semibold hover:underline"
            >
              {{ entry.first_name }} {{ entry.last_name }}
            </router-link>
            <span class="text-sm text-gray-500">
              {{ formatDate(entry.date_of_birth) }} &middot; {{ t('home.turnsAge', { age: entry.age }) }}
            </span>
          </div>
        </div>
      </VaInnerLoading>
    </VaCardContent>
  </VaCard>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { VaCard, VaCardTitle, VaCardContent, VaInnerLoading } from 'vuestic-ui'
import UserService from '@/services/UserService'

const { t } = useI18n()

const loading = ref(false)
const birthdays = ref<{ id: string; first_name: string; last_name: string; date_of_birth: Date; age: number }[]>([])

const formatDate = (date: Date) => {
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  return `${day}.${month}.`
}

onMounted(() => {
  loading.value = true
  UserService.upcomingBirthdays()
    .then((data) => {
      birthdays.value = data.map((entry) => ({
        ...entry,
        date_of_birth: new Date(entry.date_of_birth),
      }))
    })
    .finally(() => {
      loading.value = false
    })
})
</script>
